import { activity_recent, and, desc, eq, type PowerSyncDrizzleDB } from "@fieldcheck/powersync";

const DEFAULT_FEED_LIMIT = 200;

/**
 * Local activity feed (PowerSync bucket `activity_recent`, ~90 days).
 * The account SQLite only contains its buckets (personal scope + EVERYTHING
 * from its organizations), so there is no need to re-filter by user: the
 * feed IS "the organization's activity" (B2B product).
 * Canonical order: server_ts DESC (tie-break by UUIDv7 id).
 */
export function getActivityFeedQuery(db: PowerSyncDrizzleDB, options: { limit?: number } = {}) {
  return db
    .select()
    .from(activity_recent)
    .orderBy(desc(activity_recent.server_ts), desc(activity_recent.id))
    .limit(options.limit ?? DEFAULT_FEED_LIMIT);
}

/**
 * Local history for a specific entity (for the detail's "Historial" sheet).
 * Deep history (beyond retention) is requested from the API
 * (`GET /api/activity/entity/:type/:id`).
 */
export function getEntityActivityQuery(
  db: PowerSyncDrizzleDB,
  entityType: string,
  entityId: string,
  options: { limit?: number } = {},
) {
  return db
    .select()
    .from(activity_recent)
    .where(
      and(eq(activity_recent.entity_type, entityType), eq(activity_recent.entity_id, entityId)),
    )
    .orderBy(desc(activity_recent.server_ts), desc(activity_recent.id))
    .limit(options.limit ?? DEFAULT_FEED_LIMIT);
}
